<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Termékfogyás</span>
    </div>
    <div v-loading="loading" class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="Raktár"
            >
              <el-select v-model="storage" multiple placeholder="Select" style="width: 100%">
                <el-option
                  v-for="s in storages"
                  :key="s.id"
                  :label="s.name"
                  :value="s.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Időszak"
            >
              <el-date-picker
                v-model="dateRange"
                style="width: 100%;"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
            label="Esemény">
              <el-select v-model="eventType" multiple placeholder="Select">
                <el-option
                  v-for="item in eventTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :disabled="isDisabled"
                :loading="listLoading"
                icon="el-icon-tickets"
                @click="listProductConsumption"
              >
                Listázás
              </el-button>
              <el-button
                :disabled="isDisabled"
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="excelExport"
              >
                Letöltés
              </el-button>
              <el-button
                :disabled="isDisabled"
                :loading="printLoading"
                icon="el-icon-printer"
                @click="print"
              >
                Nyomtatás
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <product-consumption-list />
  </el-card>
</template>

<script>
  import ProductConsumptionList from '../../components/reports/productConsumption/List';
  import moment from 'moment';

  export default {
    components: {
      ProductConsumptionList,
    },
    data() {
      return {
        loading: false,
        downloadLoading: false,
        printLoading: false,
        filterConfig: null,
        storage: null,
        eventType: null,
        eventTypes: [
          {
            label: 'Raktárközi szállítás',
            value: 'representative-delivery'
          },
          {
            label: 'Selejtezés',
            value: 'declutter',
          },
          {
            label: 'Leltáreltérés',
            value: 'stock-taking'
          },
          {
            label: 'Vevői eladás',
            value: 'customer-sale',
          },
          {
            label: 'Képviselői eladás',
            value: 'representative-sale',
          },
          {
            label: 'Képviselők közti átadás',
            value: 'representative-transfer',
          },
          {
            label: 'Kihelyezés',
            value: 'representative-placement'
          },
          {
            label: 'Termék leadás',
            value: 'representative-drop'
          },
          {
            label: 'Beszállítói visszáru',
            value: 'supplier-return-order'
          },
          {
            label: 'Vevői visszáru',
            value: 'customer-return-order'
          }
        ],
        dateRange: [moment().startOf('year').toDate(), moment().toDate()],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment().weekday(1).toDate();
              const end = moment().weekday(7).toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment().subtract({ weeks: 1 }).weekday(1).toDate();
              const end = moment().subtract({ weeks: 1 }).weekday(7).toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment().startOf('month').toDate();
              const end = moment().endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment().subtract({ months: 1 }).startOf('month').toDate();
              const end = moment().subtract({ months: 1 }).endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment().subtract({ months: 3 }).startOf('month').toDate();
              const end = moment().subtract({ months: 1 }).endOf('month').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment().startOf('year').toDate();
              const end = moment().endOf('year').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment().subtract({ years: 1 }).startOf('year').toDate();
              const end = moment().subtract({ years: 1 }).endOf('year').toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment().startOf('year').toDate();
              const end = moment().toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment().startOf('month').toDate();
              const end = moment().toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {
      storages() {
        return this.$store.getters['storage/storages'];
      },
      isDisabled() {
        return !this.storage || !this.dateRange.length;
      },
      listLoading() {
        return this.$store.getters['productConsumption/loading'];
      },
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        if (!this.storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          let ownStorage = this.storages.find(s => s.type === 'own');
          if (ownStorage) {
            this.storage.push(ownStorage.id);
          }
        }
      },
      listProductConsumption() {
        this.$store.dispatch('productConsumption/fetchAll', `?storage_ids=${this.storage.toString()}&from=${moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm')}&to=${moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm')}&types=${this.eventType.toString()}`);
      },
      async excelExport() {
        this.downloadLoading = true;
        try {
          const excel = await axios({
            url: 'api/reports/product-consumption/download',
            method: 'POST',
            responseType: 'blob',
            data: {
              storage_ids: this.storage.toString(),
              from: moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm'),
              to: moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm'),
              types: this.eventType.toString(),
            },
          });
          saveAs(excel, 'product_consumption.xlsx');
        } catch (e) {
        }
        this.downloadLoading = false;
      },
      async print() {
        this.printLoading = true;
        let response = null;
        try {
          response = await axios.post('api/reports/product-consumption/print',  {
            storage_ids: this.storage.toString(),
            from: moment(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm'),
            to: moment(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm'),
            types: this.eventType.toString(),
          }, {
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/pdf'
            },
          });
        } catch (e) {
        }

        this.printLoading = false;

        const newBlob = new Blob([response], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        window.open(data);
      },
    }
  };
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    width: 150px;
  }
  .el-picker-panel [slot=sidebar]+.el-picker-panel__body, .el-picker-panel__sidebar+.el-picker-panel__body {
    margin-left: 150px;
  }
</style>
